import {useEffect, useState} from 'react';

export default function useAuth() {

  const [auth, setAuth] = useState("0");

  const handleStorage = () => {
    // Place for a function responsible for
    // pulling and displaying local storage data
    setAuth(sessionStorage.getItem('CURRENT_AUTH'));
  };

  useEffect(() => {
    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
  }, []);

  return auth;
};


// 갤럭시워치 API 개인별로 수집이 가능한지 여부 체크 필요함!!!!!!!!!